var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "related-entries" },
    [
      _c(
        "category-display",
        _vm._b(
          {
            key: _vm.category.id,
            attrs: {
              facets: ["in-cms"],
              "entry-facets": ["in-cms"],
              "entry-title-max-length": 120,
              entries: _vm.getEntriesOfCategory(_vm.category)
            }
          },
          "category-display",
          _vm.category,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c4229b4", { render: render, staticRenderFns: staticRenderFns })
  }
}